import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, Button } from "antd";
import {
	AppstoreOutlined,
	ShoppingCartOutlined,
	InboxOutlined,
	DatabaseOutlined,
	LogoutOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";

// key = the route path it navigates to
const NAV_ITEMS = [
	{
		label: "Dashboard",
		key: "dashboard",
		icon: <DatabaseOutlined />,
	},
	{
		label: "Production",
		key: "production",
		icon: <AppstoreOutlined />,
		children: [
			{ label: "Products List", key: "production/products" },
			{ label: "Colors List", key: "production/colors" },
		],
	},
	{
		label: "Holding Stocks",
		key: "stocks",
		icon: <DatabaseOutlined />,
		children: [{ label: "Stocks Data - New", key: "stocks/holdingv1" }],
	},
	{
		label: "Orders",
		key: "manageOrders",
		icon: <ShoppingCartOutlined />,
		children: [{ label: "Create/Edit Orders", key: "orders/manage" }],
	},
	{
		label: "Tracking",
		key: "tracking",
		children: [
			{ label: "Orders", key: "orders" },
			{ label: "Assignments", key: "assignments" },
			{ label: "Payments", key: "payments" },
		],
	},
	{
		label: "Warehouse",
		key: "warehouse",
		icon: <InboxOutlined />,
		children: [
			// { label: "Warehouse - POV V0", key: "assigned/warehouse-pov-v0" },
			{ label: "Warehouse Assignments", key: "assigned/warehouse-pov" },
		],
	},
	// {
	// 	label: "Utilities",
	// 	key: "utilities",
	// 	children: [{ label: "Data Import/Export", key: "data/import-export" }],
	// },
];

const NavbarV1 = () => {
	const { logout } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	// Derive selected key from current URL — handles page reload correctly
	const selectedKey = location.pathname.replace("/", "");

	const onClick = ({ key }) => {
		// Only leaf items (no children) should navigate
		navigate(`/${key}`);
	};

	const logoutUser = async () => {
		try {
			await logout();
			// Explicit redirect after logout (belt-and-suspenders alongside ProtectedRoute)
			navigate("/login", { replace: true });
			toast.success("Logout Successfully");
		} catch (error) {
			console.error("Logout error:", error);
		}
	};

	return (
		<header className="navbarv1">
			<Menu
				onClick={onClick}
				selectedKeys={[selectedKey]}
				mode="horizontal"
				items={NAV_ITEMS}
				style={{ flex: 1, minWidth: 0 }}
			/>
			<Button
				color="cyan"
				variant="outlined"
				icon={<LogoutOutlined />}
				onClick={logoutUser}
			>
				Logout
			</Button>
		</header>
	);
};

export default NavbarV1;
